import React, { ReactNode, useEffect } from 'react';
import { Typography } from '../../Typography/Typography';
import styles from './Notification.module.scss';
import classNames from 'classnames/bind';
import { Close } from '../../../assets/icons/Close';
import { SpeechSquare } from '../../../assets/icons/SpeechSquare';
import { SpeechBubble } from '../../../assets/icons/SpeechBubble';
import Spinner from '../../Spinner/Spinner';
import { useClickOutside } from '../../../hooks/useClickOutside';

export type TNotificationStatus = 'success' | 'error' | 'info';
export interface INotificationProps {
  status: TNotificationStatus;
  title: ReactNode;
  description?: string;
  onClose: () => void;
}
const cx = classNames.bind(styles);

const colours: Record<TNotificationStatus, string> = {
  error: styles.error,
  success: styles.success,
  info: styles.success,
};
const icons: Record<TNotificationStatus, ReactNode> = {
  error: <SpeechSquare className={cx('icon', 'white')} />,
  success: <SpeechBubble className={cx('icon', 'white')} />,
  info: <Spinner colour="salt" className={cx('icon')} />,
};

export const Notification = ({ status, title, description, onClose }: INotificationProps) => {
  const clickOutsideRef = useClickOutside<HTMLDivElement>(onClose);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onClose();
    }, 10 * 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className={cx('notification', colours[status])} ref={clickOutsideRef}>
      <div className={cx('close')} onClick={onClose} role="button">
        <Close className={cx('close-icon', 'white')} />
      </div>
      <div className={cx('main-content')}>
        {icons[status]}
        <div>
          <Typography size="M" weight="semi-bold" color="secondary">
            {title}
          </Typography>
          {description && (
            <Typography size="M" weight="regular" color="secondary" className={cx('description')}>
              {description}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
